export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
          关于刃牙漫画
        </h2>
        <div className="w-12 h-1 bg-primary-500 mx-auto rounded-full mb-6"></div>
        <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
          刃牙漫画是全网最全的刃牙系列免费漫画在线阅读平台。我们热爱《刃牙》这部由板垣恵介创作的经典格斗漫画，致力于为广大漫迷提供最完整、最流畅的免费阅读体验。
        </p>
        <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
          从最初的《刃牙》到最新的《相扑道》，本站收录了刃牙系列全部篇章，涵盖正传、续作及外传作品。采用下拉式阅读模式，无需跳转页面，滚动即可畅快追漫。高清画质还原漫画的每一处细节，让格斗的张力跃然屏上。
        </p>
        <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
          无论你是刃牙老粉重温经典，还是新读者初次入坑，这里都是你最好的刃牙漫画免费阅读选择。无需充值、无需注册，即刻开始你的刃牙之旅。
        </p>
      </div>
    </section>
  );
}